import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'bubbles-banner',
    templateUrl: './bubbles.component.html',
    styleUrls: ['./bubbles.component.css'],
    standalone: false
})
export class BubblesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
